import { ConsultaPadrao } from "../../../components/ConsultaPadrao";
import { model_categoria_financeiro } from "../../../models";

export const CategoriaFinanceiro = () => {
    const columns = [
        { field: 'catfinconta', header: 'Conta' },
        { field: 'catfindescricao', header: 'Descrição' },
        { field: 'catfintipo', header: 'Tipo', body: (e: any) => <div>{e.catfintipo === 0 ? 'RECEITA' : 'DESPESA'}</div> },
        { field: 'catfinativo', header: 'Ativo' },
        { field: 'functions', style: { width: '4rem' } }
    ];

    return (
        <ConsultaPadrao model={model_categoria_financeiro} columns={columns} />
    )
}